import Release from '../../models/Release'
import ShipmentUnit from '../../models/ShipmentUnit'

export const ReleasesModule = {
  namespaced: true,

  state: {
    release: new Release({})
  },

  getters: {
    release (state) {
      return state.release
    }
  },

  mutations: {
    setRelease (state, release = null) {
      state.release = new Release(release)
    },

    removeReleaseShipment (state, index) {
      confirm()
      {
        let action = confirm('Are you sure?')
        if (action) {
          state.release.shipments.splice(index, 1)
        }
      }
    },

    addReleaseShipment (state) {
      state.release.shipments.push(new ShipmentUnit({}))
    }
  }
}

export default ReleasesModule
